<template>
  <div class="modification-modal-group">
    <common-modal
      :name="modalCfg.name"
      :title="getMainModalTitle()"
      :primaryAction="modalCfg.primaryAction"
      :secondaryActions="modalCfg.secondaryActions"
      :onClosed="onCloseModal"
      height="auto"
      width="80%"
    >
      <template #modal-body>
        <school-event-form
          v-if="isSchoolEvent"
          :isis-event="isisEvent"
          ref="schoolFormRef"
        />

        <class-schedule-form
          v-if="!isSchoolEvent && isScheduleEditingMode"
          :isis-event="isisEvent"
          :calendar-event="calendarEvent"
          :editing-type="editingType"
          ref="classFormRef"
        />

        <class-single-event-form
          v-if="!isSchoolEvent && !isScheduleEditingMode"
          :isis-event="isisEvent"
          :editing-type="editingType"
          ref="classFormRef"
        />
      </template>
    </common-modal>

    <common-modal
      :name="modeSelectionModalCfg.name"
      :title="modeSelectionModalCfg.title"
      :primaryAction="modeSelectionModalCfg.primaryAction"
      :secondaryActions="modeSelectionModalCfg.secondaryActions"
      height="auto"
      v-if="eventType === EVENT_TYPES.classEvent"
    >
      <template #modal-body>
        <div class="md-layout">
          <div
            v-for="type in editingTypeOpts"
            :key="'editting-type-' + type.value"
            class="md-layout-item md-size-100"
          >
            <md-radio v-model="editingType" :value="type.value">{{
              type.title
            }}</md-radio>
          </div>
        </div>
      </template>
    </common-modal>
  </div>
</template>

<script>
import SchoolEventForm from "../Forms/SchoolEvent";
import ClassSingleEventForm from "../Forms/ClassEvent/Single.vue";
import ClassScheduleForm from "../Forms/ClassEvent/Schedule.vue";
import { EVENT_TYPES, EventAPI, SCHEDULE_TYPES } from "../event-utils";
import { getId, Message } from "@/helpers/utils";
import { mapGetters } from "vuex";

const MODE_SELECTION_MODAL = "mode-selection-modal";
const EDITING_MODAL = "editing-modal";

export default {
  props: ["selectedEvent"],
  components: { SchoolEventForm, ClassSingleEventForm, ClassScheduleForm },
  data() {
    return {
      modalCfg: {
        name: EDITING_MODAL,
        title: this.$t("schedule.edit_class_schedule"),
        primaryAction: {
          title: this.$t("common.update"),
          action: this.updateEvent
        },
        secondaryActions: [
          {
            title: this.$t("common.cancel"),
            action: this.hide
          }
        ]
      },
      modeSelectionModalCfg: {
        name: MODE_SELECTION_MODAL,
        title: this.$t("schedule.edit_class_schedule"),
        primaryAction: {
          title: this.$t("common.ok"),
          action: this.handleSelectedEditingType,
          disabled: true
        },
        secondaryActions: [
          {
            title: this.$t("common.cancel"),
            action: this.hideModeSelectionModal
          }
        ]
      },
      EVENT_TYPES,
      editingTypeOpts: SCHEDULE_TYPES,
      editingType: "",
      rawEventData: {},
      originalEventData: {},
      option: ""
    };
  },
  inject: ["refetchEvents"],
  computed: {
    ...mapGetters("user", { userTz: "timezone" }),
    eventType() {
      const calendarEvent = this.selectedEvent.event;

      if (!calendarEvent) return EVENT_TYPES.schoolEvent;

      const eventType =
        calendarEvent.extendedProps?.type ?? EVENT_TYPES.schoolEvent;

      return eventType;
    },
    isisEvent() {
      if (!this.selectedEvent.event) return {};
      return this.selectedEvent.event.extendedProps;
    },
    calendarEvent() {
      // refer: https://fullcalendar.io/docs/event-object
      return this.selectedEvent.event || {};
    },
    eventId() {
      return getId(this.isisEvent);
    },
    isSchoolEvent() {
      return this.eventType === EVENT_TYPES.schoolEvent;
    },
    isScheduleEditingMode() {
      return this.editingType !== SCHEDULE_TYPES.singleEvent.value;
    }
  },
  watch: {
    editingType(newEditingType) {
      this.modeSelectionModalCfg.primaryAction.disabled = !newEditingType;
    }
  },
  methods: {
    getMainModalTitle() {
      return this.isSchoolEvent
        ? this.$t("schedule.edit_event")
        : this.$t("schedule.edit_class_schedule");
    },
    open() {
      if (this.isSchoolEvent) {
        this.$modal.show(this.modalCfg.name);
        return;
      }

      // get original event here
      this.openModeSelectionModal();
    },
    hide() {
      this.$modal.hide(this.modalCfg.name);
    },
    hideModeSelectionModal() {
      this.$modal.hide(this.modeSelectionModalCfg.name);
    },
    openModeSelectionModal() {
      this.editingType = "";
      this.$modal.show(this.modeSelectionModalCfg.name);
    },
    updateEvent() {
      const eventConfig = this.isSchoolEvent
        ? this.$refs.schoolFormRef.getEventCfg()
        : this.$refs.classFormRef.getEventCfg();

      if (this.isScheduleEditingMode) {
        eventConfig.option = this.editingType;
      }

      if (!eventConfig.timezone) {
        eventConfig.timezone = this.userTz || "";
      }

      return EventAPI.edit(this.eventId, {
        eventType: this.eventType,
        eventConfig
      }).then(() => {
        this.refetchEvents();
        this.$modal.hide(this.modalCfg.name);
        Message.success(this.$t("common.successfully"));
      });
    },
    async handleSelectedEditingType() {
      this.option = this.editingType;
      this.$modal.hide(this.modeSelectionModalCfg.name);
      this.$modal.show(this.modalCfg.name);
    },
    onCloseModal() {
      // this.editingType = "";
    }
  }
};
</script>

<style lang="scss" scoped></style>
